// extracted by mini-css-extract-plugin
module.exports = {"relatedPartsCheckboxNameList":"az_Dad","column":"az_Ead","desktopListWrap":"az_Fad"};